import { ActionContext, ActionTree } from 'vuex'
import { SessionStoreInterface } from 'src/store/session/state'
import { StoreInterface } from 'src/store'
import { MutationOptions } from 'apollo-client'
import {
  QUERY_REMOVE_LESSON_SETTINGS,
  QUERY_UPDATE_LESSON_SETTINGS
} from 'src/lib/queries/lesson'
import { ItemId, ItemSettingDataObject, ItemSettingKey, UserId } from 'able-lib'
import { apolloProvider } from 'boot/apollo'
import { Token, TokenParams } from 'src/lib/mediasoup/Model'
import { generateToken, leaveSession } from 'src/lib/mediasoup/Token'
import { preparePersonalSessionSetting } from 'src/lib/tools/session'

const actions: ActionTree<SessionStoreInterface, StoreInterface> = {
  async getToken (context, tokenParams: TokenParams): Promise<Token | boolean> {
    return await generateToken(tokenParams)
  },

  async leaveSession (context, tokenParams: TokenParams): Promise<boolean> {
    console.debug('leaveSession: tokenParams:', JSON.stringify(tokenParams, null, 2))
    return await leaveSession(tokenParams)
  },

  getSession ({ commit }: ActionContext<SessionStoreInterface, StoreInterface>, data) {
    commit('startSession', data.lesson)
    commit('setSessionSettings', data.lesson?.itemSettings)
    if (process.env.DEV) console.debug('getSession:', data.lesson)
  },

  listenToLessonSetting ({ commit }: ActionContext<SessionStoreInterface, StoreInterface>, data) {
    console.debug('listenToLessonSetting:', data)
    commit('setSessionSettings', data.lessonSettings)
  },

  async updateLessonSettings ({ getters }: ActionContext<SessionStoreInterface, StoreInterface>, {
    itemId,
    itemSettings
  }: { itemId: ItemId; itemSettings: Array<ItemSettingDataObject> }): Promise<void> {
    const userSettings = getters.getUserSettings

    const { upsertSettings, removeUserSettings } = preparePersonalSessionSetting(itemId, userSettings, itemSettings)

    const options: MutationOptions = {
      mutation: QUERY_UPDATE_LESSON_SETTINGS,
      variables: {
        objects: upsertSettings,
        removeSetting: [...removeUserSettings]
      }
    }

    const { data } = await apolloProvider.defaultClient.mutate(options)
    console.debug(data)
  },

  async removeSessionSettings (context: ActionContext<SessionStoreInterface, StoreInterface>, {
    itemId,
    removeItemSettings
  }: { itemId: ItemId; removeItemSettings: Array<{ key: ItemSettingKey; userId: UserId }> }): Promise<void> {
    const removeSettings = []

    for (const removeItemSetting of removeItemSettings) {
      removeSettings.push({
        item_id: { _eq: itemId },
        key: { _eq: removeItemSetting.key },
        user_id: { _eq: removeItemSetting.userId }
      })
    }

    console.debug(removeSettings)
    const options: MutationOptions = {
      mutation: QUERY_REMOVE_LESSON_SETTINGS,
      variables: {
        removeSettings
      }
    }

    await apolloProvider.defaultClient.mutate(options)
  },

  loadLessonRecognitions ({ commit }, data) {
    commit('SET_RECOGNITIONS', data.user)
  }
}

export default actions
